// Onboarding completion state. Server-side marker is the source of truth
// (existing cross-device mechanism); localStorage is only a fast local hint.

const API_URL = process.env.REACT_APP_BACKEND_URL;
const LOCAL_KEY = 'arvexis_welcome_seen';

export const isOnboardingCompleteLocally = () => localStorage.getItem(LOCAL_KEY) === 'true';

export const markOnboardingCompleteLocally = () => localStorage.setItem(LOCAL_KEY, 'true');

// Returns true when the member still needs onboarding.
export const checkOnboardingPending = async () => {
  try {
    const res = await fetch(`${API_URL}/api/companion/welcome-status`, { credentials: 'include' });
    if (res.ok) {
      const data = await res.json();
      if (data.welcome_completed) markOnboardingCompleteLocally();
      return !data.welcome_completed;
    }
  } catch (e) {
    console.error('[Onboarding] welcome-status unavailable:', e);
  }
  // The server is the source of truth and it could not be reached. Never interrupt an existing
  // member on a transient failure: a local completion hint is honoured, and an unanswerable
  // question defers onboarding to the next successful load rather than sending a signed-in
  // member back through it.
  return false;
};

export const completeOnboarding = async () => {
  const res = await fetch(`${API_URL}/api/companion/welcome-complete`, {
    method: 'POST',
    credentials: 'include',
  });
  if (!res.ok) throw new Error(`welcome-complete failed: ${res.status}`);
  markOnboardingCompleteLocally();
};
